// GeoJSON worker updates are asynchronous. Keep the old sprites until the
// latest source has loaded and a frame has drawn it, including during animated
// radar/wind playback where the map may never reach an idle event.
export function createSpriteAtlasPruner(map, sourceId, {images, limit, getUsed, isSettled = () => true, onRemoved = () => {}}) {
    let scheduled = false, dead = false;
    function request() {
        if (dead || scheduled || images.size <= limit) return;
        scheduled = true;
        map.once('render', () => {
            scheduled = false;
            if (dead || !isSettled() || !map.getSource(sourceId) || !map.isSourceLoaded(sourceId)) return;
            const used = getUsed();
            for (const key of images) {
                if (used.has(key)) continue;
                try { map.removeImage(key); } catch { continue; }
                images.delete(key);
                onRemoved(key);
            }
        });
        map.triggerRepaint();
    }
    map.on('sourcedata', event => {if (event.sourceId === sourceId && event.isSourceLoaded) request();});
    map.once('remove', () => {dead = true;});
    return request;
}
